// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const EARLYMARK = 'https://www.earlymark.com';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  yawn: {
    root: path(ROOTS_DASHBOARD, '/yawn'),
    architectDashboard: path(ROOTS_DASHBOARD, '/yawn/architect-dashboard'),
    manufacturerDashboard: path(ROOTS_DASHBOARD, '/yawn/manufacturer-dashboard'),
    analyticsDashboard: path(ROOTS_DASHBOARD, '/yawn/analytics-dashboard'),
    project: {
      root: path(ROOTS_DASHBOARD, '/yawn/project'),
      list: path(ROOTS_DASHBOARD, '/yawn/project/list'),
      new: path(ROOTS_DASHBOARD, '/yawn/project/new'),
    },
    schedule: {
      root: path(ROOTS_DASHBOARD, '/yawn/schedule'),
      list: path(ROOTS_DASHBOARD, '/yawn/schedule/list'),
      new: path(ROOTS_DASHBOARD, '/yawn/schedule/new'),
    },
    spec: {
      root: path(ROOTS_DASHBOARD, '/yawn/spec'),
      list: path(ROOTS_DASHBOARD, '/yawn/spec/list'),
      new: path(ROOTS_DASHBOARD, '/yawn/spec/new'),
    },
    product: {
      root: path(ROOTS_DASHBOARD, '/yawn/product'),
      list: path(ROOTS_DASHBOARD, '/yawn/product/list'),
      new: path(ROOTS_DASHBOARD, '/yawn/product/new'),
    },
    company: {
      root: path(ROOTS_DASHBOARD, '/yawn/company'),
      list: path(ROOTS_DASHBOARD, '/yawn/company/list'),
      new: path(ROOTS_DASHBOARD, '/yawn/company/new'),
    },
    user: {
      list: path(ROOTS_DASHBOARD, '/yawn/user/list'),
    },
    constructionProject: {
      root: path(ROOTS_DASHBOARD, '/yawn/constructionProject'),
      all: path(ROOTS_DASHBOARD, '/yawn/constructionProject/all'),
    },
    settings: {
      root: path(ROOTS_DASHBOARD, '/settings'),
      user: path(ROOTS_DASHBOARD, '/user/account'),
      display: path(ROOTS_DASHBOARD, '/settings/display'),
    },
    admin: {
      root: path(ROOTS_DASHBOARD, '/yawn/admin'),
      productmapping: path(ROOTS_DASHBOARD, '/yawn/admin/productMapping'),
      stats: path(ROOTS_DASHBOARD, '/yawn/admin/stats'),
      standardLink: path(ROOTS_DASHBOARD, '/yawn/admin/standardLink'),
    },
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey'),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post'),
  },
};

export const PATH_DOCS = path(EARLYMARK, '/specsuite');
export const PATH_EARLYMARK = 'https://www.earlymark.com';
